/* Bundle quick view (BFE) — Acelera.
   Lazy-fetcht de bundelpagina, pakt de <bundle-configurator> eruit, strip hero + USP-balk en
   injecteert de compacte configurator in een <dialog>. De configurator zelf (self-initializing
   custom element) verzorgt maat/kleur-keuze + '1-klik voeg de set toe'. Sluit zodra de set toegevoegd is. */
if (!customElements.get('bundle-quick-view')) {
  class BundleQuickView extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.body = this.querySelector('[data-qv-body]');
      this.url = this.dataset.bundleUrl;
      if (!this.dialog || !this.url) return;

      // De '+'-trigger zit als sibling in de kaart (aria-controls = dialog-id).
      const card = this.closest('[data-bo-card]');
      this.trigger = card && card.querySelector('[data-qv-open][aria-controls="' + this.dialog.id + '"]');
      this.trigger && this.trigger.addEventListener('click', () => this.open());

      // Sluiten: kruisje + klik op de backdrop.
      this.querySelectorAll('[data-qv-close]').forEach((btn) => btn.addEventListener('click', () => this.close()));
      this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.close(); });

      // Zodra de set in de cart zit (configurator vuurt cart:change / cart:refresh) → modal dicht,
      // zodat de cart-drawer erbovenop komt.
      this._onCart = () => { if (this.dialog.open) this.close(); };
      document.addEventListener('cart:change', this._onCart);
      document.addEventListener('cart:refresh', this._onCart);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:change', this._onCart);
      document.removeEventListener('cart:refresh', this._onCart);
    }

    open() {
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
      if (this.dataset.loaded === 'false') this.load();
    }

    close() {
      if (typeof this.dialog.close === 'function' && this.dialog.open) this.dialog.close();
      else this.dialog.removeAttribute('open');
    }

    async load() {
      this.dataset.loaded = 'pending';
      try {
        const res = await fetch(this.url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');

        const cfg = doc.querySelector('bundle-configurator');
        if (!cfg) throw new Error('no configurator');

        // Pak de hele #shopify-section-wrapper mee (bevat de scoped <style> + het element).
        const section = cfg.closest('[id^="shopify-section-"]') || cfg;
        // JS-scripts weghalen (loader is al geladen), maar de <script type="application/json">
        // met de per-kaart variantdata BEHOUDEN — die heeft de configurator nodig voor de opties.
        section.querySelectorAll('script:not([type="application/json"])').forEach((s) => s.remove());
        section.querySelectorAll('.bundle-configurator-bfe__hero, .bundle-configurator-bfe__usps').forEach((n) => n.remove());

        this.body.innerHTML = '';
        this.body.appendChild(document.importNode(section, true));
        this.dataset.loaded = 'true';
      } catch (err) {
        this.dataset.loaded = 'false';
        const msg = this.body.querySelector('[data-qv-loading]');
        if (msg) msg.textContent = (this.dataset.errorText || 'Kon de bundel niet laden.');
      }
    }
  }
  customElements.define('bundle-quick-view', BundleQuickView);
}
